var getNative = require('./_getNative');

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/lodash/_nativeCreate.js
// module id = 587
// module chunks = 0 1 2 3 4 5 6 7 8